import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth.service';
import { IdentityService } from '../identity.service';
import { firstValueFrom } from 'rxjs';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { LDFeatureManager } from 'src/app/shared/services/ld-feature-manager';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    constructor(
        private readonly auth: AuthService,
        private readonly identityService: IdentityService,
        private readonly ldFeatureManager: LDFeatureManager,
        public router: Router
    ) {}

    async canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        if (this.identityService.enforceOAuth) {
            await firstValueFrom(this.identityService.isAuthenticated$);
            if (!this.identityService.hasOAuth || !this.identityService.current) {
                let targetPath = this.identityService.getCurrentLocationPath();
                if (!this.identityService.loginPages.some((p) => targetPath.startsWith(p))) {
                    const auth0FixNovaLoginRedirect = await firstValueFrom(
                        this.ldFeatureManager.isEnabled(FeatureFlag.Auth0FixNovaLoginRedirect)
                    );
                    if (auth0FixNovaLoginRedirect) {
                        targetPath = targetPath || undefined;
                    } else {
                        targetPath = targetPath ? encodeURIComponent(targetPath?.replace('/', '')) : undefined;
                    }
                    this.router.navigate(['/signin'], { queryParams: { target: targetPath } });
                }
                return false;
            }
        } else if (!this.auth.isAuthenticated()) {
            this.auth.setLoginRedirect(state.url);

            this.router.navigate(['/signin']);

            return false;
        }
        return true;
    }
}
